export class PresenceDTO {
  constructor(
    public idParticipant: string,
    public iufSupervisor: string,
    public activity_id: number
  ) {}
}
